import { PureComponent } from 'react';
import { ConnectedProps, connect } from 'react-redux';

import { ApiUserEnvironment } from 'api/userEnvironment/types/ApiUserEnvironment';
import { EmailSignupForm } from 'components/Email/EmailSignupForm';
import { FormUsageContext } from 'components/Form/Form';
import { showModal as reduxShowModal } from 'modules/main/store/ducks/modal';
import {
  User,
  updateUserEnvironment,
} from 'modules/main/store/ducks/userEnvironment';
import { trackSignUp } from 'utils/analytics/track/trackSignUp';
import { configureTrackJs } from 'utils/configureTrackJs';
import { getThirdPartyLoginUrl } from 'utils/getThirdPartyLoginUrl';
import { postJson } from 'utils/http';
import { resetRecaptcha } from 'utils/recaptcha';
import { saveTemporaryStorageAndGenerateRedirectURL } from 'utils/temporaryStorage';
import { RouteComponentProps, withRouter } from 'utils/withRouter';

type InitialProps = {
  analyticsTitle: string;
  usageContext: FormUsageContext;
  redirectTo: string | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  savedListing: Record<string, any> | null | undefined;
  subscribedSubsite: string | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSignup?: (...args: Array<any>) => any;
  onLogin?: ((arg0: User) => void) | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loginOverrideFn?: (...args: Array<any>) => any;
  compactView?: boolean;
  hideLoginBlock?: boolean;
  customButtonText?: string;
  // @ts-expect-error TS(7051): Parameter has a name but no type. Did you mean 'ar... Remove this comment to see the full error message
  setEmailInUse?: (string) => void;
};

type Props = InitialProps & RouteComponentProps & PropsFromRedux;

class UnconnectedEmailSignupFormContainer extends PureComponent<Props> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line class-methods-use-this
  get initialValues() {
    return {
      email: '',
      recaptchaKey: 0,
      gRecaptchaResponse: undefined,
    };
  }

  showLoginModal = (email?: string, initialWarning?: string) => {
    const { showModal, redirectTo, savedListing, subscribedSubsite, onLogin } =
      this.props;

    showModal('LOGIN', {
      // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
      redirectTo,
      // @ts-expect-error TS(2322): Type 'Record<string, any> | null | undefined' is n... Remove this comment to see the full error message
      savedListing,
      // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
      subscribedSubsite,
      email,
      // @ts-expect-error TS(2322): Type '((arg0: ApiUser) => void) | null | undefined... Remove this comment to see the full error message
      onLogin,
      initialWarning,
    });
  };

  getLoginUrlAndState = (email?: string) => {
    const { redirectTo, savedListing, subscribedSubsite } = this.props;
    return {
      to: '/login',
      state: {
        redirectTo,
        savedListing,
        subscribedSubsite,
        email,
      },
    };
  };

  getThirdPartyLoginUrl = (provider: 'facebook' | 'google' | 'apple') => {
    const { location, redirectTo, savedListing, subscribedSubsite } =
      this.props;
    return getThirdPartyLoginUrl({
      provider,
      redirectTo: redirectTo || `${location.pathname}${location.search}`,
      savedListing,
      subscribedSubsite,
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit = ({ values, handleError, updateSubmitting }: any) => {
    const { email, recaptchaKey, gRecaptchaResponse } = values;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    saveTemporaryStorageAndGenerateRedirectURL(this.props.redirectTo, {
      // TODO: Fix this the next time the file is edited.
      // @ts-expect-error TS(2322): Type 'Record<string, any> | null | undefined' is n... Remove this comment to see the full error message
      // eslint-disable-next-line react/destructuring-assignment
      listing: this.props.savedListing,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      subscribedSubsiteId: this.props.subscribedSubsite,
    })
      .then((redirectTo) =>
        postJson<ApiUserEnvironment>('/data/website/signup-email', {
          email,
          gRecaptchaResponse,
          redirectTo,
        }),
      )
      .then((userEnvironment) => {
        trackSignUp(userEnvironment.user, 'Email');
        configureTrackJs(userEnvironment.user?.id);
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.updateUserEnvironment(userEnvironment);

        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        if (this.props.onSignup) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.onSignup();
        }

        updateSubmitting(false);
      })
      .catch((error) => {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        const errorArray = error.responseJson && error.responseJson.errors;
        const emailInUseError =
          // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
          errorArray &&
          errorArray.find(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (e: any) => e.name === 'email' && e.type === 'alreadyInUse',
          );

        if (emailInUseError) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          if (this.props.setEmailInUse) {
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            this.props.setEmailInUse(email);
          } else {
            this.showLoginModal(
              email,
              'An account with this email exists. Did you mean to login?',
            );
          }
        } else {
          resetRecaptcha();
          handleError(error, {
            recaptchaKey: recaptchaKey + 1,
            gRecaptchaResponse: undefined,
          });
        }

        updateSubmitting(false);
      });
  };

  render() {
    const { analyticsTitle, usageContext } = this.props;

    return (
      <EmailSignupForm
        analyticsTitle={analyticsTitle}
        usageContext={usageContext}
        initialValues={this.initialValues}
        showLoginModal={this.showLoginModal}
        getLoginUrlAndState={this.getLoginUrlAndState}
        getThirdPartyLoginUrl={this.getThirdPartyLoginUrl}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        loginOverrideFn={this.props.loginOverrideFn}
        onSubmit={this.onSubmit}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        compactView={this.props.compactView}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        hideLoginBlock={this.props.hideLoginBlock}
        // TODO: Fix this the next time the file is edited.
        // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
        // eslint-disable-next-line react/destructuring-assignment
        customButtonText={this.props.customButtonText}
      />
    );
  }
}

const connector = connect(null, {
  showModal: reduxShowModal,
  updateUserEnvironment,
});

type PropsFromRedux = ConnectedProps<typeof connector>;

export const EmailSignupFormContainer = withRouter(
  connector(UnconnectedEmailSignupFormContainer),
);
